import { render, staticRenderFns } from "./DepartmentRoleMapping.vue?vue&type=template&id=c1f64112"
import script from "./DepartmentRoleMapping.vue?vue&type=script&lang=js"
export * from "./DepartmentRoleMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports